<template>
  <router-view v-if="$route.name === 'login'" />
  <div v-else class="shell">
    <aside class="sidebar" aria-label="管理菜单">
      <div class="brand">
        <span class="brand-icon" aria-hidden="true">🌱</span>
        <div class="brand-name"><strong>星露谷 AI</strong><small>我的农场管理屋</small></div>
      </div>
      <div class="nav-scroll">
        <div v-for="group in menuGroups" :key="group.title" class="menu-group">
          <div class="nav-heading">{{group.title}}</div>
          <router-link v-for="item in group.items" :key="item.path" class="nav-item" :to="item.path">
            <span class="nav-icon" aria-hidden="true">{{item.icon}}</span>
            <span>{{item.title}}</span>
          </router-link>
        </div>
      </div>
      <div class="sidebar-foot"><span class="foot-dot"></span>愿你的农场每天都有好天气</div>
    </aside>
    <div class="workspace">
      <header class="header">
        <div class="header-location">
          <button class="menu-toggle" type="button" aria-label="打开菜单" @click="drawerOpen=true">☰</button>
          <div><div class="header-greeting">欢迎来到你的农场 🌾</div><strong>{{currentTitle}}</strong></div>
        </div>
        <div class="header-actions">
          <div class="profile"><span class="profile-icon" aria-hidden="true">Q</span><span class="account-name">{{authState.user?.username || '管理员'}}</span></div>
          <el-button text @click="signOut" :loading="exiting">退出登录</el-button>
        </div>
      </header>
      <main class="content"><router-view /></main>
      <footer class="app-footer">🌿 星露谷 AI · 愿每个季节都有好故事</footer>
    </div>
    <el-drawer v-model="drawerOpen" direction="ltr" size="min(310px,88vw)" :with-header="false" class="mobile-drawer">
      <div class="mobile-brand">🌱 星露谷 AI</div>
      <div v-for="group in menuGroups" :key="group.title" class="menu-group">
        <div class="nav-heading">{{group.title}}</div>
        <router-link v-for="item in group.items" :key="item.path" class="nav-item" :to="item.path" @click="drawerOpen=false">
          <span class="nav-icon" aria-hidden="true">{{item.icon}}</span><span>{{item.title}}</span>
        </router-link>
      </div>
    </el-drawer>
  </div>
</template>
<script setup>
import {computed,ref} from 'vue'
import {useRoute,useRouter} from 'vue-router'
import {ElMessage} from 'element-plus'
import {authState,logout} from './auth'
const router=useRouter(),route=useRoute()
const exiting=ref(false),drawerOpen=ref(false)
const menuGroups=[
  {title:'农场日常',items:[
    {path:'/',title:'农场概览',icon:'🏡'},
    {path:'/game',title:'游戏服务器',icon:'🌾'},
    {path:'/players',title:'玩家与小屋',icon:'👩‍🌾'},
    {path:'/companion',title:'AI 伙伴',icon:'✦'}
  ]},
  {title:'农场管理',items:[
    {path:'/settings',title:'农场与联机设置',icon:'⚙'},
    {path:'/mods',title:'MOD（游戏模组）',icon:'🧩'},
    {path:'/saves',title:'游戏存档',icon:'📖'},
    {path:'/backups',title:'自动备份',icon:'🧺'}
  ]},
  {title:'我的账户',items:[{path:'/account/password',title:'账号与安全',icon:'🔑'}]}
]
const titleMap={'/':'农场概览','/game':'游戏服务器','/players':'玩家与小屋','/companion':'AI 伙伴','/settings':'农场与联机设置','/mods':'MOD（游戏模组）','/saves':'游戏存档','/backups':'自动备份','/account/password':'账号与安全'}
const currentTitle=computed(()=>titleMap[route.path]||'农场管理')
async function signOut(){
 if(exiting.value)return
 exiting.value=true
 try{await logout();ElMessage.success('已安全退出');await router.replace({name:'login'})}
 catch(_){ElMessage.warning('网络暂时不可用，请重新登录验证账户状态');await router.replace({name:'login'})}
 finally{exiting.value=false}
}
</script>
<style scoped>
.shell{display:flex;min-height:100vh}
.sidebar{position:sticky;top:0;flex:0 0 256px;height:100vh;padding:26px 17px 19px;display:flex;flex-direction:column;overflow:auto;background:linear-gradient(180deg,#eaf1e1 0%,#e5efdc 72%,#dfebd5);border-right:1px solid #d6dfcd;color:#335343}
.brand{padding:1px 12px 24px;display:flex;align-items:center;gap:11px;border-bottom:1px solid #d0dec8}
.brand-icon{background:#faf7e7;width:45px;height:45px;border-radius:14px;display:grid;place-items:center;font-size:24px;box-shadow:0 3px 10px #57745416}
.brand-name strong{display:block;font-size:19px;letter-spacing:.5px}.brand-name small{color:#819681;display:block;font-size:11px;margin-top:3px}
.nav-scroll{overflow:auto;min-height:0;flex:1;padding-top:5px}.menu-group{margin-top:16px}.nav-heading{font-size:11px;letter-spacing:1px;padding:9px 15px;color:#87a087;font-weight:700}
.nav-item{display:flex;gap:12px;align-items:center;border-radius:11px;padding:11px 13px;margin:3px 0;color:#54715c;font-size:13px;transition:background .18s,color .18s}
.nav-item:hover{background:#ffffff8c;color:#2e6741}
.nav-item.router-link-exact-active{background:#fffef7;color:#376646;font-weight:750;box-shadow:0 3px 12px #71886820}
.nav-item .nav-icon{display:grid;place-items:center;width:23px;font-size:17px}
.sidebar-foot{color:#9aac95;font-size:11px;text-align:center;line-height:1.6;border-top:1px solid #d1decc;padding-top:18px;margin-top:auto}.foot-dot{display:inline-block;width:7px;height:7px;background:#86b382;border-radius:50%;margin-right:6px}
.workspace{flex:1;min-width:0;display:flex;flex-direction:column}.header{min-height:80px;background:#fffef9d9;border-bottom:1px solid #e7ebdd;display:flex;justify-content:space-between;align-items:center;padding:15px clamp(18px,3.1vw,48px);gap:15px}
.header-location{display:flex;align-items:center;gap:12px}.header-greeting{color:#8c9b87;font-size:11px;margin-bottom:5px}.header-location strong{color:#385a42;font-size:16px}
.header-actions{display:flex;align-items:center;gap:16px}.profile{display:flex;gap:8px;align-items:center}.profile-icon{width:35px;height:35px;border-radius:50%;display:grid;place-items:center;background:#e8f2e3;border:1px solid #dae6d4;color:#547f56;font-size:14px;font-weight:800}
.account-name{font-size:13px;font-weight:700;color:#476650}.content{width:100%;max-width:1500px;margin:0 auto;padding:clamp(18px,2.8vw,40px);flex:1}.app-footer{text-align:center;padding:18px 10px 28px;color:#a2ad98;font-size:11px}
.menu-toggle{display:none;background:#eef4e8;border:1px solid #d8e5d1;border-radius:10px;color:#4e7a55;width:40px;height:40px;cursor:pointer;font-size:18px}
.mobile-brand{font-size:19px;font-weight:800;color:#446c4a;margin-bottom:18px}
@media(max-width:950px){.sidebar{flex-basis:210px;padding:20px 10px}.brand{padding:0 8px 20px}.nav-item{padding:10px 8px;font-size:12px}}
@media(max-width:760px){.sidebar{display:none}.menu-toggle{display:grid;place-items:center}.header{min-height:67px}.header-greeting{display:none}.content{padding:18px 14px 26px}.account-name{display:none}.header-actions{gap:3px}.app-footer{padding-top:7px}}
</style>
<style>
.mobile-drawer .el-drawer__body{background:#eaf1e1;padding:25px 18px;overflow-y:auto}
.mobile-drawer .nav-item{display:flex;align-items:center;gap:13px;padding:11px 12px;color:#456e4f;border-radius:10px;font-size:14px}
.mobile-drawer .nav-icon{width:25px;font-size:18px}
.mobile-drawer .nav-item.router-link-exact-active{background:#fffdf5;font-weight:750}
.mobile-drawer .nav-heading{font-size:11px;color:#7c967a;letter-spacing:1px;margin:16px 0 5px}
</style>
